<template>
  <div class="height">
      <div class="heng">
          <img :src="require('@/assets/images/heng.svg')" alt="">
      </div>
       <div class="navigation">
          <div class="flex">
              <ul class="onhengbank">
                  <li :class="comname=='index'?'on':''"></li>
                  <li :class="comname=='exintroduce'?'on':''"></li>
                  <li :class="comname=='forum'?'on':''"></li>
                  <li :class="comname=='enterprise'?'on':''"></li>
                  <li :class="comname=='enterprise2'?'on':''"></li>
                  <li :class="comname=='specimens'?'on':''"></li>
                  <li :class="comname=='dynamic'?'on':''"></li>
                  <li :class="comname=='associatedMedia'?'on':''"></li>
                  <!-- <li :class="comname=='mediaFocus'?'on':''"></li> 媒体聚焦 -->
                  <li :class="comname=='information'?'on':''"></li>
                  <li :class="comname=='contactus'?'on':''"></li>
              </ul>
              <ul class="menu">
                  <li :class="comname=='index'?'on':''"><router-link :to="{name:'index'}">首页</router-link></li>
                  <li :class="comname=='exintroduce'?'on':''"><router-link :to="{name:'exintroduce',query:{id:1}}">大会介绍</router-link></li>
                  <li :class="comname=='forum'?'on':''"><router-link :to="{name:'forum'}">同期活动</router-link></li>
                  <li :class="comname=='enterprise'?'on':''"><router-link :to="{name:'enterprise',query:{id:1}}">参展企业</router-link></li>
                  <li :class="comname=='enterprise2'?'on':''"><router-link :to="{name:'enterprise',query:{id:2}}">观展企业</router-link></li>
                  <li :class="comname=='specimens'?'on':''"><router-link :to="{name:'specimens'}">展会集锦</router-link></li>
                  <li :class="comname=='dynamic'?'on':''"><router-link :to="{name:'dynamic'}">媒体聚焦</router-link></li>
                  <li :class="comname=='associatedMedia'?'on':''"><router-link :to="{name:'associatedMedia'}">合作媒体</router-link></li>
                  <!-- <li :class="comname=='mediaFocus'?'on':''"><router-link :to="{name:'mediaFocus'}">媒体聚焦</router-link></li> -->
                  <li :class="comname=='information'?'on':''"><router-link :to="{name:'information'}">资料下载</router-link></li>
                  <li :class="comname=='contactus'?'on':''"><router-link :to="{name:'contactus'}">联系我们</router-link></li>
              </ul>
          </div>
      </div>
    <el-carousel height="400px">
      <el-carousel-item v-for="(item,index) in list" :key="index">
        <img :src="item" alt="唐山·‘物流行业+行业物流’智能发展博览会" style="width:100%"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  name: "topmenu",
  data() {
    return {
      list: [require('@/assets/images/as.jpg'),require('@/assets/images/ac.jpg'),],
    };
  },
  props:["comname"]
};
</script>
<style scoped>
.el-carousel__item{
  display: flex;
  justify-content: center;
}
.height {
  height: 615px;
  position: relative;
  min-width: 1370px;
}
.height .el-image__inner{
    width: auto;
    height: 100%;
}
.heng img{
  width: 100%;
}
.navigation{
    background-color: #ffffff;
    /* position: absolute; */
    z-index: 10;
    width: 100%;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
}
.navigation .menu{
  justify-content: center;
  font-weight: bold;
  /* background: url('../../assets/images/tab-bg.jpg'); */
  background: #073290;
}
.wdleft{
  width: 505px;
}
.flex{
  flex: 1;
}
.menu{
  display: flex;
  justify-content: flex-end;
}
.menu li{
  padding: 0 1.5% 0;
  height: 60px;
  line-height: 60px;
  width: 80px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
  position: relative;
  display: inline-block;
}
.menu li a{
  color: #fff;
  font-size: 16px;
}
.menu .on a{
  color: #fff;
  font-size: 16px;
}

.menu li:after {
  content: '';
  position: absolute;
  left: auto;
  top: 32%;
  right: 0;
  height: 35%;
  width: 1px;
  background-color: #e6e6e6;
}
.menu li:last-child::after{
  display: none;
}
.onhengbank{
  background: #f5f5f5;
  height: 3px;
  display: flex;
  justify-content: center;
}
.onhengbank li{
  height: 2px;
  width: 80px;
  padding: 0 1.5% 0;
  position: relative;
}
.onhengbank li.on::after{
  position: absolute;
  content: "";
  left: 5px;
  top: 3px;
  width: 95%;
  height: 2px;
  background-color: #fff;
}
.ml25{
  margin: 25px 10px 0 2%;
  display: inline-block;
}
</style>